import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UtilConfig} from 'app/autenticacion/servicios/UtilConfig';
import {Usuario} from "../../seguridad/usuario/recursos/modelo/usuario";

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-preview-retencion',
    templateUrl: './view/previewRetencion.component.html',
    styleUrls: ['./css/previewRetencion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewRetencionComponent implements OnInit {

    /**
     * PARAMETROS DE CONFIGURACION GENERAL
     *
     */
    @Input() documento;
    @Input() title;
    @Input() totalLetter;
    /**
     * FORMULARIOS Y VALIDADORES
     *
     */

    /**
     * VARIABLES DE CONTROL DE VISUALIZACION
     *
     */
    monedaType = {
        'USD': 'Dolares',
        'EUR': 'EUROS',
        'GBP': 'LIBRAS ESTERLINAS',
        'PEN': 'SOLES',
    };

    /**
     * VARIABLES DE DATA
     *
     */
    usuarioSession: Usuario;
    cargoDescuentoGlobal = 0.0;
    recargoConsumo = 0.0;


    constructor(private util: UtilConfig,
                private cd: ChangeDetectorRef) {
        this.usuarioSession = this.util.getCurrentUser();


    }

    ngOnInit(): void {
        if (this.documento != null &&
            this.documento.cab != null &&
            this.documento.cab.cargoDescuento != null &&
            this.documento.cab.cargoDescuento.length > 0) {
            this.documento.cab.cargoDescuento.forEach((cargo) => {
                if (cargo.codigoCargoDescuento == '02') {
                    this.cargoDescuentoGlobal = cargo.montoCargoDescuento;
                }
                if (cargo.codigoCargoDescuento == '46') {
                    this.recargoConsumo = cargo.montoCargoDescuento;
                }
            });
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/previewRetencion/previewRetencion.component.ts